import { Phone, MessageCircle } from "lucide-react";
import { useSettings, waLink, telLink } from "@/lib/site";

export const StickyCTA = () => {
  const settings = useSettings();
  return (
    <div className="lg:hidden fixed bottom-3 left-3 right-3 z-40 rounded-2xl bg-[rgba(14,15,16,0.9)] backdrop-blur border border-white/12 p-2 flex gap-2 shadow-[0_18px_40px_rgba(0,0,0,0.45)]">
      <a href={waLink(settings)} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp-button"
        className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-xl bg-[#C8A24A] text-[#141517] font-semibold">
        <MessageCircle className="w-5 h-5" /> WhatsApp
      </a>
      <a href={telLink(settings)} data-testid="sticky-call-button"
        className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-xl border border-white/18 text-[#F7F2E8]">
        <Phone className="w-5 h-5" /> Ara
      </a>
    </div>
  );
};

export default StickyCTA;
